import { StyledCarousel } from '../style';
import { FallbackImage } from '../../UploadImage/fallBack/FallBackImage';
import React from 'react';
import { BannerProps, ImageProps } from '../../../types/BannerData';

interface BannersGalleryProps {
  bannerImages?: ImageProps[];
  banner?: BannerProps;
  full?: boolean;
}

export const BannersGallery = ({
  bannerImages,
  banner,
  full,
}: BannersGalleryProps) => {
  const showDots = bannerImages && bannerImages?.length > 1;

  return (
    <StyledCarousel
      dots={showDots}
      rootClassName={full ? 'full' : ''}
      autoplay={banner?.autoplay}
      autoplaySpeed={(banner?.autoplay_speed || 3) * 1000}
    >
      {bannerImages?.map((image, index) => {
        const content = (
          <FallbackImage
            src={image.url_original}
            preview={false}
            type={banner?.type}
            className="banner-image-wrapper"
          />
        );

        return (
          <div
            className={`banner-image-wrapper ${full ? '' : 'container'}`}
            key={`image-${index}`}
          >
            {image.url_to ? (
              <a href={image.url_to} target="_blank" rel="noopener noreferrer">
                {content}
              </a>
            ) : (
              content
            )}
          </div>
        );
      })}
    </StyledCarousel>
  );
};
